import {
  extendsModule, baseForm, registerMfModule, moduleKeys,
} from 'src/store/base';
import * as types from 'src/store/types';

import playableCardFormGroup from './playable-card-form-group';

export default extendsModule(baseForm, {
  state: {
    _moduleKey: 'playable-card-form',
    _formGroups: moduleKeys([playableCardFormGroup]),
    isAppDownload: false,
  },
  mutations: {
    [types.UPDATE_IS_APPDOWNLOAD](state, value) {
      state.isAppDownload = !!value;
    },
  },
  actions: {
    resetPlayable({ dispatch }) {
      dispatch('fillForm', {
        playable_url: [],
        resetSwitch: [],
      });
    },
    // 在界面上显示试玩素材，并设置选中项
    openAndSetPlayableUrl({ dispatch }, playableUrl = []) {
      const playable_url = (Array.isArray(playableUrl) ? playableUrl : [playableUrl])
        .map(url => url && url.trim())
        .filter(Boolean);
      if (playable_url.length) {
        const resetSwitch = playable_url.map(item => !!item);
        dispatch('fillForm', {
          playable_url,
          resetSwitch,
        });
      }
    },
  },
  modules: registerMfModule([playableCardFormGroup]),
});
